"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = exports.LAYOUT_SIZES = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.LAYOUT_SIZES = {
    Button: { width: 100, height: 21 },
    ButtonWithoutCounter: { width: 64, height: 21 },
    Link: { width: 50, height: 21 },
    LinkWithoutIcon: { width: 30, height: 21 },
    Icon: { width: 32, height: 32 },
};
var getIframeParams = function (compData) { return ({
    layout: compData.style,
    text: compData.text || 'Share',
}); };
var getLayout = function (value) { return exports.LAYOUT_SIZES[value] || exports.LAYOUT_SIZES.Button; };
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    var iframeParams = getIframeParams(compData);
    return {
        iframeParams: iframeParams,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    var style = compData.style;
    var layout = getLayout(style);
    return {
        '--width': layout.width + "px",
        height: layout.height + "px",
    };
});
//# sourceMappingURL=VKShareButton.js.map